export class EnvironmentModel {
    productServiceUrl: string;
    customerServiceUrl: string;
    commerceOrderServiceUrl: string;
    marketingServiceUrl: string;
    contentServiceUrl: string;
    imageUploadServiceUrl: string;
    communicationServiceUrl: string;
    blogServiceUrl: string;
    commonCallServiceUrl: string;
    testimonialImageUrl: string;
}